(() => {
  if (window.muyaFooterBreadcrumbReady) return;
  window.muyaFooterBreadcrumbReady = true;
  const init = (root = document) => {
    root.querySelectorAll('[data-muya-footer-breadcrumb]').forEach((nav) => {
      if (nav.dataset.muyaBreadcrumbReady) return;
      nav.dataset.muyaBreadcrumbReady = 'true';
      const mobile = window.matchMedia('(max-width: 767px)');
      let interacted = false;
      const align = () => {
        if (!nav.isConnected || !mobile.matches || interacted) return;
        const style = getComputedStyle(nav);
        const rtl = style.direction === 'rtl';
        nav.scrollLeft = rtl ? -nav.scrollWidth : nav.scrollWidth;
        const active = nav.querySelector('[aria-current="page"]');
        const padding = parseFloat(style.paddingInlineStart) || 0;
        if (active && active.getBoundingClientRect().width > nav.clientWidth - padding * 2) {
          const current = active.getBoundingClientRect();
          const bounds = nav.getBoundingClientRect();
          // For an active title wider than the phone, reveal its beginning;
          // the rest stays available through horizontal scrolling.
          nav.scrollLeft += rtl ? current.right - bounds.right + padding : current.left - bounds.left - padding;
        }
      };
      const controller = new AbortController();
      const { signal } = controller;
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((event) => {
        nav.addEventListener(event, () => { interacted = true; }, { passive: true, signal });
      });
      const onChange = () => { interacted = false; requestAnimationFrame(align); };
      mobile.addEventListener('change', onChange);
      requestAnimationFrame(align);
      document.fonts?.ready.then(align);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(nav)) return;
        controller.abort();
        mobile.removeEventListener('change', onChange);
      }, { signal });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
